import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d5ad0828"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container wow animate__animated animate__fadeInLeft",
  "data-wow-duration": "2s",
  "data-wow-delay": "0.1s"
};
var _hoisted_2 = {
  class: "textArea"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "全国献血率数据统计", -1);
});

var _hoisted_4 = {
  class: "data-cards"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-year"
  }, "2023年", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-value"
  }, "12.2‰", -1);
});

var _hoisted_7 = {
  class: "progress-container"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-desc"
  }, "全国平均千人口献血率", -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-year"
  }, "2024年", -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-value"
  }, "11.2‰", -1);
});

var _hoisted_11 = {
  class: "progress-container"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-desc"
  }, "全国平均千人口献血率", -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-year"
  }, "临床需求", -1);
});

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-value"
  }, "20~25‰", -1);
});

var _hoisted_15 = {
  class: "progress-container"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-desc"
  }, "平均千人口献血率需求", -1);
});

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-year"
  }, "发达国家", -1);
});

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-value"
  }, "≥30‰", -1);
});

var _hoisted_19 = {
  class: "progress-container"
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-desc"
  }, "平均千人口献血率", -1);
});

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-year"
  }, "落后国家", -1);
});

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-value"
  }, "≤10‰", -1);
});

var _hoisted_23 = {
  class: "progress-container"
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-desc"
  }, "平均千人口献血率", -1);
});

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "data-note"
  }, "数据显示，我国当前献血率介于落后国家和发达国家之间，但仍低于临床需求水平，2024年较2023年略有下降。", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "data-card",
    style: _normalizeStyle({
      animationDelay: '0.1s'
    })
  }, [_hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "progress-bar",
    style: _normalizeStyle({
      width: '12.2‰',
      backgroundColor: $setup.getProgressColor(12.2)
    })
  }, null, 4)]), _hoisted_8], 4), _createElementVNode("div", {
    class: "data-card",
    style: _normalizeStyle({
      animationDelay: '0.2s'
    })
  }, [_hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "progress-bar",
    style: _normalizeStyle({
      width: '11.2‰',
      backgroundColor: $setup.getProgressColor(11.2)
    })
  }, null, 4)]), _hoisted_12], 4), _createElementVNode("div", {
    class: "data-card",
    style: _normalizeStyle({
      animationDelay: '0.3s'
    })
  }, [_hoisted_13, _hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: "progress-bar",
    style: _normalizeStyle({
      width: '22.5‰',
      backgroundColor: $setup.getProgressColor(22.5)
    })
  }, null, 4)]), _hoisted_16], 4), _createElementVNode("div", {
    class: "data-card",
    style: _normalizeStyle({
      animationDelay: '0.4s'
    })
  }, [_hoisted_17, _hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: "progress-bar",
    style: _normalizeStyle({
      width: '30‰',
      backgroundColor: $setup.getProgressColor(30)
    })
  }, null, 4)]), _hoisted_20], 4), _createElementVNode("div", {
    class: "data-card",
    style: _normalizeStyle({
      animationDelay: '0.5s'
    })
  }, [_hoisted_21, _hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
    class: "progress-bar",
    style: _normalizeStyle({
      width: '10‰',
      backgroundColor: $setup.getProgressColor(10)
    })
  }, null, 4)]), _hoisted_24], 4)]), _hoisted_25])]);
}